<template>
<span>
  <v-select v-model="model" :items="values" :label="field.name" hint="Wybierz wartosci" item-text="name"
            item-value="code"
            persistent-hint></v-select>
  {{ description }}
</span>
</template>

<script>
import {input} from '@/mixins/input'
import FieldType from "../../../enums/fieldType"

export default {
  mixins: [input],
  data() {
    return {
      watchedFieldInterface: {},
      timeoutFunc: null,
      timeoutTime: 1000,
      values: [],
      oldValue: ""
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE,
    watchedValue: function () {
      if (this.watchedFieldInterface == undefined) {
        return undefined
      }
      return this.getParent().getFieldValue(this.watchedFieldInterface.id)
    }
  },
  watch: {
    watchedValue: {
      handler: function (newVal) {
        if (newVal != undefined)
          this.setNewTimeoutFunc(newVal)
      },
      deep: true
    }
  },
  created() {
    this.watchedFieldInterface = this.getParent().getFieldInfo(this.field.options['depend_field_id'])
  },
  methods: {
    fetchFields(code) {
      if (code == undefined || code == "") return

      let data = this.$store.getters.relatedValues(this.field.options.group_type_id, code)
      if (data) {
        this.values = data.relatedValues
        return
      }

      this.$store.dispatch('loadRelatedValuesByCode', {
        'group_type_id': this.field.options.group_type_id,
        code
      }).then(data => this.values = data)

    },
    setNewTimeoutFunc(newVal) {
      if (newVal != this.oldValue) {
        this.oldValue = newVal
        clearTimeout(this.timeoutFunc)
        let code = newVal
        if (this.watchedFieldInterface.type == FieldType.RADIO) {
          let radioVal = this.watchedFieldInterface.values.find(el => el.key == newVal)
          code = radioVal ? radioVal.value : code
        }

        this.timeoutFunc = setTimeout(this.fetchFields.bind(this, code), this.timeoutTime)
      }
    }
  },
}
</script>

<style>

</style>
